import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {getBonuses} from '/redux/action/coach.action';
import {bonuses} from '/redux/selector/coach.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {withProps} from '/util/selector.util';

import {Bonuses} from './Bonuses';

export default connect(
  createStructuredSelector({
    bonuses,
    currentScreen: currentScreen,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
  dispatch => ({
    getBonuses: ({date, formattedCurrentPeriod}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getBonuses({date, formattedCurrentPeriod})),
  }),
)(Bonuses);
